import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./styles/ThemeToggle.scss";
import "aos/dist/aos.css";
import "aos/dist/aos.js";
import "./styles/main.scss";
import "./styles/global.css";
import "./styles/responsive.scss";
import "./styles/navigation.scss";

const savedTheme = localStorage.getItem("theme");
if (savedTheme === "dark") {
  document.body.classList.add("dark-theme");
} else {
  document.body.classList.remove("dark-theme");
}

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId =  process.env.REACT_APP_AUTH0_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Auth0Provider
          domain={domain}
          clientId={clientId}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: `https://${domain}/api/v2/`,
            scope: "openid profile email",
          }}
          useRefreshTokens={true}
          cacheLocation="localstorage"
        >
          <App />
        </Auth0Provider>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);
